<template lang="pug">
span.feedback-icon
  v-icon.icon(size="16" color="white") {{ iconName }}
</template>

<script>
export default {
  name: 'FeedbackIcon',
  props: {
    iconName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.feedback-icon {
  display: inline-block;
  background: #333;
  border-radius: 4px;
  width: 24px;
  height: 24px;

  .icon {
    margin: 4px;
  }
}
</style>